// extracted by mini-css-extract-plugin
export default {"campo":"CampoFormulario_campo__jF8QH","campoInput":"CampoFormulario_campoInput__MaODh"};